<template>
  <section
    :class="[
      'tabs',
      {
        'tabs--small': small,
      },
    ]"
  >
    <div class="tabs--internal">
      <Button
        v-for="(item, i) in tabList"
        :key="i"
        :label="item"
        :is-active="i === activeTab"
        is-fluid
        is-clear
        @action="$emit('action', { index: i, label: item })"
      />
    </div>
  </section>
</template>

<script>
export default {
  name: 'Tabs',

  components: {
    Button: () => import('./Button.vue'),
  },

  data() {
    return {
      tabList: [],
    };
  },

  props: {
    activeTab: {
      type: Number,
      default: 0,
    },
    small: {
      type: Boolean,
      default: false,
    },
    activeData: {
      type: Object,
      default: () => {},
    },
  },

  mounted() {
    this.activeData.content.forEach((content) => {
      const tabTitle = (content.tabTitle) ? content.tabTitle : content.config.title;
      this.tabList.push(tabTitle);
    });
    //hacky race condition fix with card.vue setting index to -1 on mounting
    this.$nextTick(() => {
      this.$emit('action', { index: 0, label: this.tabList[0] });
    });
  },
};
</script>

<style lang="scss" scoped>
.tabs {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  padding: 10px 0;

  .button {
    &:not(:last-child) {
      margin-right: rem(10);
    }
  }

  &--small {
    .button {
      font-size: rem(12);
      color: #646464;
      border: 2px solid #707070;
      margin-right: 0 !important;
      white-space: nowrap;
      padding: 8px 24px;

      @include iPadProStyles {
        font-size: rem(16);
        padding: 12px 36px;
      }

      &--active {
        background: #72cac32b;
        border: 2px solid #646464;
      }
    }
  }

  &--internal {
    display: inline-flex;
    flex-direction: row;
  }
}
</style>
